import { useState } from 'react';
import BooleanValue from '@components/booleanValue/BooleanValue';
import { VerifyButton } from '@routes/adminRoutes/sharedComponents/SharedStyledComponents';
import { adminUpdateUserV2 } from '@utils/api';
import { useToast } from '@contexts/Toast.context';
import { useConfirm } from '@contexts/Confirm.context';

const ApproveUser = ({ cellValue, uuid, email }) => {
	const { addToast } = useToast();
	const { confirm } = useConfirm();
	const [approve, setApproved] = useState(cellValue);

	const handleApprove = async () => {
		const userConfirmed = await confirm({
			title: 'Approve User',
			message: (
				<>
					Are you sure you want to approve <strong>{email}</strong>?
				</>
			),
		});

		if (userConfirmed) {
			try {
				// v2: approval is a partial user update (verified_by_admin).
				// The helper throws on failure, so reaching here means success.
				await adminUpdateUserV2(uuid, { verified_by_admin: true });
				setApproved(true);
				addToast({
					id: 'approve-user-success',
					bg: 'success',
					title: 'User is approved.',
				});
			} catch (err) {
				console.error('Failed to approve user', err);
				addToast({
					id: 'approve-user-error',
					bg: 'danger',
					title: 'Failed to approve user.',
				});
			}
		}
	};

	return (
		<>
			<BooleanValue value={approve} />

			{!approve && (
				<VerifyButton size="sm" onClick={handleApprove}>
					Approve
				</VerifyButton>
			)}
		</>
	);
};

export default ApproveUser;
